import { mapActions } from 'vuex';

export default {
  name: 'ServiceCategory',

  props: {
    title: {
      type: String,
      default: (() => '')
    },
    icon: {
      type: String,
      default: (() => '')
    }
  },

  data() {
    return {

    };
  },

  computed: {},

  methods: {
    ...mapActions(['selectCategory']),
    handleClick() {
      this.selectCategory(this.title);
    }
  },
}


// WEBPACK FOOTER //
// ./src/components/Services/ServiceCategory/component.js